import Header from '../../components/Header/Header';
import AboutUs from '../../components/AboutUs/AboutUs';
import WhatsappFloatingButton from '../../components/WhatsappFloatingButton/WhatsappFloatingButton';
import Certifications from '../../components/Certifications/Certifications';
import Footer from '../../components/Footer/Footer';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Video from '../../components/Video/Video';
import { AboutUsWrapper, VideoWrapper } from './AboutUs.styled'
import WhyChooseUs from '../../components/WhyChooseUs/WhyChooseUs';



const AboutUsPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        // Delay to ensure DOM is ready
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);
  
  return (
    <>
      <Header />
      <AboutUsWrapper>
        <AboutUs />
      </AboutUsWrapper>
      <VideoWrapper>
        <Video videoId="PJgQ5EHZn4k" />
      </VideoWrapper>
      <WhyChooseUs />
      <Footer />
      <WhatsappFloatingButton />
    </>
  );
}

export default AboutUsPage;
